class TeamList {
	constructor(selectionType) {

		this._editList = new OrderedList3();
		this._checkList = new OrderedList2();

		this._dialog = Dialog.Modal('teams', _("Teams"), LARGE, null, [
			this._editList.container,
			this._newButton1 = btn('btn i-rg i-add')
		]);
		
		this._popup = Dialog.Popup('teams', [
			this._checkList.container,
			this._newName = div(null, [
				p('smaller', _("Name")),
				this._newNameInput = text(),
				this._newSave = btn('popup-list-btn', _("Save"))
			]),
			this._newButton2 = btn('popup-list-btn i-rg i-add')
		], 'left-start', _("TEAMS")).sticky();
		
		this._newName.style.display = 'none';

		onEv(this._newButton1, 'click', this.newInEdit.bind(this));
		onEv(this._newButton2, 'click', this.newInCheck.bind(this));
		onEv(this._newNameInput, 'paste', event => {
			this._newSave.disabled = event.clipboardData.getData('text').length == 0;
		});
		onEv(this._newNameInput, 'keyup', event => {
			switch (event.keyCode) {
				case AC.ENTER_KEY: this.saveInCheck(); break;
				case AC.ESCAPE_KEY: this.cancelInCheck(); break;
			}
			this._newSave.disabled = this._newNameInput.value === '';
		})

		onEv(this._newSave, 'click', this.saveInCheck.bind(this));
		
		this._selectionType = selectionType;
		this._selectionIds = null;

		this._activeTeam = null;
		this._filterGroup = false;
		
		this.init();
	}

	set filterGroup(value) {
		this._filterGroup = value;
	}

	get filters() {
		return this._editList.items.map(i => [i.id, i.name]);
	}

	init (){
		ajg('team/list', null, null, (reply) => {
			if (reply.teams && Array.isArray(reply.teams)) {
				reply.teams.forEach((data) => {
					let team = Team.fromArray(data, this);
					this._editList.addItem(team, team.getOrder, team.getRow, team.getDrag);
					this._checkList.addItem(team, team.getOrder, team.getChkRow);
				}, this);
				if (this._filterGroup) {
					this._filterGroup.update();
				}
			}
		}, this);
    }

	/**
	 * Opens the edit dialog, to edit / reorder tags or add new ones
	 */
	openDialog() {
		this._selectionIds = null;
		this._dialog.open();
		this._editList.update();
	}

	mapOne(id, button){
		this._selectionIds = [id];
		this.openPopup(button);
	}

	mapSelection(ids, button) {
		this._selectionIds = ids;
		this.openPopup(button);
	}

	openPopup(button) {
		ajg('team/map', [
			'selectionType=' + this._selectionType,
			'selectionIds=' + encodeURI(this._selectionIds.join(','))
		], null, (reply) => {
			if (reply.map && Array.isArray(reply.map)) {
				reply.map.forEach(row => {
					this._checkList.getItemById(row._id).prime(row.status);
				}, this);
			}
		}, this);
		this._popup.handle(button);
	}

	newInEdit () {
		let team = Team.blank(this);
		this._editList.addItem(team, team.getOrder, team.getRow, team.getDrag);
		this._checkList.addItem(team, team.getOrder, team.getChkRow);
		team.edit();
	}

	newInCheck () {
        this._newName.style.display = 'block';
		this._newButton2.style.display = 'none';
		this._newSave.disabled = this._newNameInput.value === '';
		this._newNameInput.select();
    }

	cancelInCheck () {
		this._newNameInput.value = '';
		this.saveInCheck();
	}

	saveInCheck () {
		if (this._newNameInput.value.length) {
			let team = Team.blank(this);
			team.name = this._newNameInput.value;
			this._editList.addItem(team, team.getOrder, team.getRow, team.getDrag);
			this._checkList.addItem(team, team.getOrder, team.getChkRow);
			team.save();
			this._newNameInput.value = '';
		}
		this._newName.style.display = 'none';
		this._newButton2.style.display = 'block';
	}

	remove(team) {
		this._editList.removeItem(team);
		this._checkList.removeItem(team);
	}

	prepDrag(row, ev) {
		if (this._activeTeam !== null) return;
		this._editList.prepDrag(row, ev);
	}
}